



























































































import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import GraphCard from './components/GraphCard.vue';

@Component({
  components: {GraphCard},
})
export default class App extends Vue {

  private query = '';

  private focusSearch() {
    (this.$refs.searchBar as HTMLElement).focus();
  }

  private search() {
    function stripUsernameFromURL(query: string) {
      try {
        const url = new URL(query);
        if (url.hostname.endsWith('twitter.com')) {
          return url.pathname.replace('/', '');
        }
      } catch (err) {
        if (err instanceof TypeError) { // invalid URL
          return query;
        } else {
          throw err;
        }
      }
      return query;
    }
    const removeAtSign = (handle: string) => handle.startsWith('@') ? handle.slice(1) : handle;
    if (this.query) {
      this.query = removeAtSign(stripUsernameFromURL(this.query));
      this.viewProfile(this.query);
    }
  }

  private viewProfile(handle: string) {
    this.$router.push(`/profile/${handle}`);
  }
}
